import { Component, OnInit } from "@angular/core";
import { PhoneNumberUtil, PhoneNumberFormat } from "google-libphonenumber";

import { ApiService } from "src/app/api.service";
import { APIResults } from "src/app/sharedinterfaces";
declare const BrandVars;

@Component({
	selector: "app-account",
	templateUrl: "./account.component.html",
	styleUrls: ["./account.component.scss"]
})
export class AccountComponent implements OnInit {
	public brand = BrandVars;

	oldpassword = "";
	newpassword = "";
	matchpassword = "";

	passresult?: string = undefined;
	passerror?: string = undefined;

	smsnumber: string;
	muteimports: boolean;
	mutecommfails: boolean;
	notifyorgs: NotificationOrg[] = [];

	constructor(private api: ApiService) { }

	async ngOnInit() {
		const [notifyassets, smsnumber, mutes] = await Promise.all([
			this.api.GetNotifyAssets(),
			this.api.GetSMSNumber(),
			this.api.GetNotificationOptions(),
		]);
		const orgs: NotificationOrg[] = [];
		for (const asset of notifyassets) {
			// Add the org and fleet to the bins if necessary
			let org = orgs.find(item => item.organization_name === asset.organization_name);
			if (!org) {
				org = { organization_name: asset.organization_name, fleets: [] };
				orgs.push(org);
			}
			let fleet = org.fleets.find(item => item.fleet_name === asset.fleet_name);
			if (!fleet) {
				fleet = { fleet_name: asset.fleet_name, assets: [] };
				org.fleets.push(fleet);
			}
			// Add the asset to the org's fleet
			fleet.assets.push(asset);
		}
		// Sort the orgs and fleets
		for (const org of orgs) {
			org.fleets.sort((a, b) => a.fleet_name.localeCompare(b.fleet_name));
		}
		orgs.sort((a, b) => a.organization_name.localeCompare(b.organization_name));
		this.notifyorgs = orgs;
		this.smsnumber = smsnumber;
		this.muteimports = mutes.mute_imports;
		this.mutecommfails = mutes.mute_commfails;
	}

	ChangePassword() {
		this.passerror = undefined;
		this.passresult = undefined;
		this.api.ChangePassword(this.oldpassword, this.newpassword).then(() => {
			this.passresult = "Password changed";
		}).catch(err => {
			if (err.error?.message) {
				this.passerror = err.error.message;
			} else if (err && err.status && err.status === 401) {
				this.passerror = "Password incorrect";
			} else {
				this.passerror = "Password change failed";
			}
		});
	}

	async UpdateSMS() {
		// First fix the number to the correct format
		const util = PhoneNumberUtil.getInstance();
		const parsed = util.parse(this.smsnumber, "US");
		if (!util.isValidNumber(parsed)) {
			throw new Error("Not a valid phone number");
		}
		const fixed = util.format(parsed, PhoneNumberFormat.E164);
		this.smsnumber = fixed;
		await this.api.SetSMSNumber(fixed);
	}

	async UpdateNotifications() {
		await this.api.SetNotificationOptions(this.muteimports, this.mutecommfails);
	}

	async UpdateAssets() {
		const mapped = [];
		for (const org of this.notifyorgs) {
			for (const fleet of org.fleets) {
				for (const asset of fleet.assets) {
					mapped.push([asset.asset_id, asset.enable_email, asset.enable_sms]);
				}
			}
		}
		await this.api.SetNotifyAssets(mapped);
	}

}
export interface NotificationOrg {
	organization_name: string;
	fleets: {
		fleet_name: string;
		assets: APIResults.NotificationAsset[];
	}[];
}